import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS  } from '@angular/common/http';
import { HttpClientInMemoryWebApiModule } from 'angular-in-memory-web-api';
import { ClipboardModule } from 'ngx-clipboard';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthService } from './modules/auth/services/auth.service';
import { environment } from 'src/environments/environment';
// All services
import { ApiModule as CMSApiModule, BASE_PATH as CMS_BASE_PATH } from 'src/app/core/services/content-service-mgt';
import { ApiModule as DNDApiModule, BASE_PATH as DND_BASE_PATH } from 'src/app/core/services/dnd-cnt-pro';
import { ApiModule as RateApiModule, BASE_PATH as RATE_BASE_PATH } from 'src/app/core/services/rate-billing-mgt';
import { ApiModule as BillingRateApiModule, BASE_PATH as BILLING_RATE_BASE_PATH } from 'src/app/core/services/billing-rate';

import { ApiModule as WalletApiModule, BASE_PATH as WALLET_BASE_PATH } from 'src/app/core/services/wallet-billing-mgt';
import { ApiModule as PartnerContentApiModule, BASE_PATH as  PARTNERCONTENT_BASE_PATH} from 'src/app/core/services/CoureHub-Partner-Content';
import { ApiModule as ServicePlanApiModule, BASE_PATH as SERVICEPLAN_BASE_PATH  } from 'src/app/core/services/CoureHub-Service-Plan';
import { ApiModule as RouteApiModule, BASE_PATH as ROUTE_BASE_PATH } from 'src/app/core/services/route-mgt';
import { ApiModule as DssmsApiModule, BASE_PATH as DSSMS_BASE_PATH} from 'src/app/core/services/delivery-system-sms';
import { ApiModule as PlatformFeeModule, BASE_PATH as PLATFORMFEE_BASE_PATH } from 'src/app/core/services/hub-platformfee-service';
import { ApiModule as senderIdApiModule, BASE_PATH as SENDERID_BASE_PATH } from 'src/app/core/services/sender-id-request-mgt-service';
import { ApiModule as BillingAccountModule, BASE_PATH as BILLINGACCOUNT_BASE_PATH } from 'src/app/core/services/billing-account';
import { ApiModule as  SERVICECREATIONApiModule, BASE_PATH  as SERVICE_CREATION_BASE_PATH  } from 'src/app/core/services/CoureHub-ServiceCreation';
import { ApiModule as  routeMgtApiModule, BASE_PATH  as  ROUTE_MGT_BASE_PATH} from 'src/app/core/services/route-mgt';
import { ApiModule as  broadcastApiModule, BASE_PATH  as  BROADCAST_BASE_PATH} from 'src/app/core/services/Broadcast-Service';
import { ApiModule as  addressbookApiModule, BASE_PATH  as  ADDRESS_BOOK_BASE_PATH} from 'src/app/core/services/Addressbook-service';
import { ApiModule as  AuthenticationApiModule, IDENTITY_BASE_PATH  as  AUTHENTICATION_BASE_PATH} from 'src/app/core/services/identity-server';
import { ApiModule as  HubTransactionLogApiModule,  BASE_PATH as  HUB_TRANSACTION_LOG_BASE_PATH } from 'src/app/core/services/Hub-transactionLog';
import { ApiModule as  ServiceOwnerApiModule,  BASE_PATH as  Service_Owner_BASE_PATH } from 'src/app/core/services/Service-Owner-Mgt';
import { ApiModule as  UssdServiceApiModule,  BASE_PATH as Ussd_Campaign_BASE_PATH } from 'src/app/core/services/ussd-campaign-service';
import { ApiModule as  VerifyContentApiModule,  BASE_PATH as VERIFYCONTENT_BASE_PATH } from 'src/app/core/services/content-verification-service';
import { ApiModule as  QuizcampaignApiModule,  BASE_PATH as QUIZCAMPAIGN_BASE_PATH } from 'src/app/core/services/quiz-campaign-service';
import { ApiModule as  CourehubDssmsApiModule,  BASE_PATH as COUREHUBDSSMS_BASE_PATH} from 'src/app/core/services/courehub-dssms-api';
// #fake-start#
import { FakeAPIService } from './_fake/fake-api.service';
import { AuthConfigModule } from './auth/auth-config.module';
import { CommonModule, DatePipe, TitleCasePipe } from '@angular/common';
 import { NgxSpinnerModule } from 'ngx-spinner';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { FormsModule } from '@angular/forms';
import { CustomDatePipePipe } from './modules/vas-service/custom-date-pipe.pipe';
import { PaginationControlComponent } from './shared/pagination-control/pagination-control.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { SpinnerHelperComponent } from './shared/utilities/spinner-helper/spinner-helper.component';
import { LoaderInterceptorService } from './shared/interceptors/loader-interceptor.service';

// #fake-end#

function appInitializer(authService: AuthService) {
  return () => {
    return new Promise((resolve) => {
      //@ts-ignore
      authService.getUserByToken().subscribe().add(resolve);
    });
  };
}

@NgModule({
  declarations: [AppComponent, SpinnerHelperComponent],
  imports: [
    CommonModule,
    SweetAlert2Module.forRoot(),
    FormsModule,
    BrowserModule,
    UssdServiceApiModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot(),
    HttpClientModule,
    ClipboardModule,
    // All services
    SERVICECREATIONApiModule,
    routeMgtApiModule,
    CMSApiModule,
    HubTransactionLogApiModule,
    DNDApiModule,
    RateApiModule,
    BillingRateApiModule,
    WalletApiModule,
    BillingAccountModule,
    ServiceOwnerApiModule,
    PartnerContentApiModule,
    ServicePlanApiModule,
    RouteApiModule,
    AuthenticationApiModule,
    DssmsApiModule,
    PlatformFeeModule,
    senderIdApiModule,
    routeMgtApiModule,
    broadcastApiModule,
    addressbookApiModule,
    VerifyContentApiModule,
    QuizcampaignApiModule,
    CourehubDssmsApiModule,

    // #fake-start#
    environment.isMockEnabled
      ? HttpClientInMemoryWebApiModule.forRoot(FakeAPIService, {
          passThruUnknownUrl: true,
          dataEncapsulation: false,
        })
      : [],
    // #fake-end#
    AppRoutingModule,
    InlineSVGModule.forRoot(),
    NgbModule,
    NgxSpinnerModule,
    AuthConfigModule,
    NgxPaginationModule
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializer,
      multi: true,
      deps: [AuthService],
    },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptorService, multi: true },
    // { provide: BASE_PATH, useValue: environment.deliverySystemBaseUrl },
    { provide: BILLINGACCOUNT_BASE_PATH , useValue: environment.billingAccountServiceBaseUrl },
    { provide: CMS_BASE_PATH, useValue: environment.contentServiceManagerMongoBaseUrl },
    { provide: PARTNERCONTENT_BASE_PATH , useValue: environment.courehubPartnerContentBaseUrl },
    { provide: SERVICEPLAN_BASE_PATH , useValue: environment.courehubServicePlanBaseUrl },
    { provide: ROUTE_BASE_PATH, useValue: environment.routeManagementServiceBaseUrl },
    { provide: DSSMS_BASE_PATH, useValue: environment.deliverySystemBaseUrl },
    { provide: DND_BASE_PATH, useValue: environment.dndContentProcessingBaseUrl },
    { provide: PLATFORMFEE_BASE_PATH, useValue: environment.hubPlatformFeeBaseUrl},
    { provide: RATE_BASE_PATH, useValue: environment.rateBillingMgtServiceBaseUrl },
    { provide: BILLING_RATE_BASE_PATH, useValue: environment.rateBillingMgtServiceBaseUrl },
    { provide: RATE_BASE_PATH, useValue: environment.rateBillingMgtServiceBaseUrl },
    { provide: Ussd_Campaign_BASE_PATH, useValue: environment.ussdCampaignServiceBaseUrl },
    { provide: SENDERID_BASE_PATH, useValue: environment.senderIdRequestBaseUrl },
    { provide: WALLET_BASE_PATH, useValue: environment.walletBillingMgtServiceBaseUrl },
    { provide: SERVICE_CREATION_BASE_PATH, useValue: environment.courehubServicecreationBaseUrl },
    { provide: ROUTE_MGT_BASE_PATH, useValue: environment.routeManagementServiceBaseUrl},
    { provide:BROADCAST_BASE_PATH, useValue:environment.BrodacastserviceBaseUrl }, 
    { provide:ADDRESS_BOOK_BASE_PATH, useValue:environment.AddressbookServiceBaseUrl }, 
    { provide:AUTHENTICATION_BASE_PATH, useValue:environment.authServerUrl }, 
    { provide:HUB_TRANSACTION_LOG_BASE_PATH, useValue: environment.HubTransactionLogBaseUrl },
    { provide:Service_Owner_BASE_PATH, useValue: environment.ServiceOwnerBaseUrl },
    { provide:VERIFYCONTENT_BASE_PATH, useValue: environment.verifyContentServiceBaseUrl },
    { provide:QUIZCAMPAIGN_BASE_PATH, useValue: environment.quizCampaignServiceBaseUrl },
    { provide:COUREHUBDSSMS_BASE_PATH, useValue: environment.coureHubDsSmsApi },
    // {}
    [DatePipe],
    [TitleCasePipe],
    [CustomDatePipePipe]
  ],
  bootstrap: [AppComponent],
  exports:[NgxSpinnerModule],

})
export class AppModule {}
